import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsLimitPipe } from './products-limit.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ ProductsLimitPipe ],
    exports: [ ProductsLimitPipe ],
})
export class ProductsLimitPipeModule {}
